import styled from "@emotion/styled";
import { DialogContent } from "@ui-kit/Dialog";

export const SearchDialogContent = styled(DialogContent)`
    width: calc(100vw - 2rem);
    height: calc(100vh - 2rem);
    max-width: 840px;
    max-height: calc(100% - 25%);
`;
